import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { memo } from 'react';
import { useTheme } from '../hooks/useTheme.js';

var BasePath = function () { return (jsx("rect", { className: "base", x: "5", y: "5", width: "82", height: "50", rx: "25", ry: "25", fill: "#BFBFBF", stroke: "none" })); };
var FocusRingPath = function () { return (jsx("rect", { className: "focusRing", x: "0", y: "0", width: "92", height: "60", rx: "30", ry: "30", fill: "#CCE0F5", stroke: "none" })); };
var FocusBorderPath = function () { return (jsx("rect", { className: "focusBorder", x: "6", y: "6", width: "80", height: "48", rx: "24", ry: "24", fill: "none", stroke: "red", strokeWidth: "2" })); };
var KnobPath = function () { return (jsx("circle", { className: "knob", cx: "30", cy: "30", r: "20", fill: "#FFFFFF" })); };
var CheckPath = function () { return (jsx("polyline", { className: "check", points: "19, 31 27, 39 42, 21", stroke: "red", strokeWidth: "5", fill: "none" })); };
var SwitchSvg = memo(function (props) {
    var handleStyleProps = useTheme().handleStyleProps;
    var id = props.id, _a = props.themeKey, themeKey = _a === void 0 ? "switchSvg" : _a, restProps = __rest(props, ["id", "themeKey"]);
    var svgCssProps = handleStyleProps(restProps, {
        themeKey: themeKey,
        baseStyle: {
            display: "block",
            boxSizing: "border-box",
        },
    });
    return (jsxs("svg", __assign({}, svgCssProps, { viewBox: "0 0 92 60", id: id, "data-testid": id }, { children: [jsx(FocusRingPath, {}), jsx(BasePath, {}), jsx(FocusBorderPath, {}), jsxs("g", __assign({ className: "knob-group" }, { children: [jsx(KnobPath, {}), jsx(CheckPath, {})] }))] })));
});

export { SwitchSvg };
//# sourceMappingURL=SwitchSvg.js.map
